import type { EntityEvent } from '@racemap/sdk/schema/entityEvents';
import type { User_Legacy } from '@racemap/utilities/types/users';
import type { Immutable } from 'immer';
import type { AssignedToType } from '../AlertsFilter';

export function getAlertsByAssignment(
  alerts: Array<EntityEvent> | undefined,
  assignedTo: AssignedToType,
  currentUser: Immutable<User_Legacy> | null,
): Array<EntityEvent> {
  if (!alerts || alerts.length === 0) return [];
  if (assignedTo === 'me' && currentUser) {
    return alerts.filter(
      (alert: EntityEvent) => alert.stateEditedBy?.toString() === currentUser.id,
    );
  }
  if (assignedTo === 'others' && currentUser) {
    return alerts.filter(
      (alert: EntityEvent) =>
        alert.stateEditedBy && alert.stateEditedBy.toString() !== currentUser.id,
    );
  }
  if (assignedTo === 'none') {
    return alerts.filter((alert: EntityEvent) => !alert.stateEditedBy);
  }
  return alerts;
}
